var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"letters"},_vm._l((_vm.letters),function(item){return _c('p',{key:item.key},[_vm._v(_vm._s(item))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }